import React from 'react';
import PriceTableImage from 'assets/price-table.png';
import { Flex, Image, Link } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const AnimatedImage = motion(Image);

export const PriceTable = React.memo(() => {
  return (
    <Flex justifyContent="center">
      <Link
        href="https://promo.hungfooktong.com/hftcms/index.php?option=com_content&view=article&id=967"
        target="_blank"
        _focus={{ border: 'none' }}
      >
        <AnimatedImage
          cursor="pointer"
          draggable="false"
          userSelect="none"
          src={PriceTableImage}
          width="100%"
          maxWidth={800}
          pt={0}
          pl={{ base: 3, sm: 2, md: 0 }}
          pr={{ base: 3, sm: 2, md: 0 }}
          pb={2}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.1 }}
          outline="none"
        />
      </Link>
    </Flex>
  );
});
